// extracted by mini-css-extract-plugin
export default {"mid-box":"MyInfoWithdraw_mid-box__CJv2u","mid":"MyInfoWithdraw_mid__YwYnz","botm":"MyInfoWithdraw_botm__8D01J","txt-box":"MyInfoWithdraw_txt-box__9s1CF"};